import React from "react";
import { cl } from "../helpers/general";
import { GRADIENT_1 } from "../styles";

type Props = {
  smallTitle: string;
  bigTitle: string;
  description?: string;
  className?: string;
}

export const SectionDescription = (props: Props) => {
  return (
    <div className={cl("flex flex-col mb-12", props.className)}>
      <div
        className={cl(
          "text-transparent bg-clip-text mb-2",
          GRADIENT_1
        )}
      >
        {props.smallTitle}
      </div>
      <div className="text-white text-3xl sm:text-5xl">{props.bigTitle}</div>
      {props.description && <p className="mt-8 opacity-80 leading-7">{props.description}</p>}
    </div>
  );
};
